import { CommonModule } from '@angular/common';
import { Component, Input, output } from '@angular/core';
import {
  CcdlButtonComponent,
  CcdlInitialsPipe,
  CcdlTimeAgoPipe,
} from '@cpm-pr1618001/ng-design-lib';
import {
  ContactStatusNotification,
  Notifications,
} from 'src/app/store/user-management/state/user-management.state';

@Component({
  selector: 'fm-notifications',
  standalone: true,
  imports: [
    CommonModule,
    CcdlInitialsPipe,
    CcdlTimeAgoPipe,
    CcdlButtonComponent,
  ],
  templateUrl: './notifications.component.html',
  styleUrl: './notifications.component.scss',
})
export class NotificationsComponent {
  @Input() notifications?: Notifications[];
  @Input() refreshKey?: number;
  @Input() isProcessing = false;

  onContactDeclined = output<Notifications>();
  onContactAccepted = output<Notifications>();
  onLoadMoreNotifications = output<number>();

  contactDeclined(notification: Notifications): void {
    if (this.isProcessing) {
      return;
    }
    this.onContactDeclined.emit(notification);
  }

  contactAccepted(notification: Notifications): void {
    if (this.isProcessing) {
      return;
    }
    this.onContactAccepted.emit(notification);
  }

  getMessageParts(notification: Notifications): {
    before: string;
    after: string;
  } {
    const isRequester = notification.isRequester ?? true;

    switch (notification.status) {
      case ContactStatusNotification.REQUEST_SENT:
        return { before: 'Contact request sent to ', after: '.' };
      case ContactStatusNotification.REQUEST_RECEIVED:
        return { before: '', after: ' sent you a contact request.' };
      case ContactStatusNotification.REQUEST_APPROVED:
        return { before: 'You approved ', after: "'s contact request." };
      case ContactStatusNotification.REQUEST_ACCEPTED:
        return isRequester
          ? { before: '', after: ' accepted your contact request.' }
          : { before: 'You approved ', after: "'s contact request." };
      case ContactStatusNotification.REQUEST_DENIED:
        return isRequester
          ? { before: '', after: ' declined your contact request.' }
          : { before: 'You declined ', after: "'s contact request." };
      default:
        return { before: '', after: ` sent a contact request.` };
    }
  }

  getTargetName(notification: Notifications): string {
    return `${notification.firstName ?? ''} ${notification.lastName ?? ''}`.trim();
  }

  loadMoreNotifications(): void {
    const offsetLimit = this.notifications ? this.notifications.length : 0;
    this.onLoadMoreNotifications.emit(offsetLimit);
  }
}
